import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-business-case',
  templateUrl: './icon-business-case.component.html',
  styles: []
})
export class IconBusinessCaseComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
